<template>

  <div class="hello">
    <div v-if="showWelcome">
      <img @click="showWelcome = false" src="../assets/img/wel.jpg" alt=""
        style="width: 100vw;height: 100vh;object-fit: cover;display: block;">
    </div>
    <div v-else>

      <img src="../assets/img/head.png" alt="" style="width: 100%;height: auto;">
      <div class="form-ct">
        <h4 style="font-size: 18px;margin-left: 10px;color: white;">登录</h4>

        <div class="form">

          <van-form ref="form" @submit="onSubmit">
            <div style="color: white;padding-left: 16px;margin-bottom: 10px;">请填写员工登录信息</div>
            <!-- <van-field v-model="info.company" name="company" label="分公司" placeholder="请输入分公司"
              :rules="[{ required: true, message: '请输入分公司' }]" /> -->
            <!-- <van-field v-model="info.team" name="team" label="车队" placeholder="请输入车队"
              :rules="[{ required: true, message: '请输入车队' }]" /> -->
            <van-field v-model="info.name" name="name" label="姓名" placeholder="请输入姓名"
              :rules="[{ required: true, message: '请输入姓名' }]" />
            <van-field v-model="info.number" name="number" label="工号" placeholder="请输入工号"
              :rules="[{ required: true, message: '请输入工号' }]" />
            <van-field v-model="info.mobile" name="mobile" label="手机号" placeholder="请输入手机号"
              :rules="[{ required: true, message: '请输入手机号' }]" />
            <van-field v-model="info.code" name="code" label="验证码" placeholder="请输入验证码"
              :rules="[{ required: true, message: '请输入验证码' }]">
              <template #button>
                <van-button :disabled="countdown > 0" size="small" @click="getCode"
                  style="background: transparent; border: 1px solid white; color: white;">
                  {{ countdown > 0 ? `${countdown}s` : '获取验证码' }}
                </van-button>
              </template>
            </van-field>
            <div style="margin: 16px;">
              <van-button round block style="background: rgb(255, 220, 46);border: none;font-weight: bold;"
                native-type="submit">登录</van-button>
            </div>
          </van-form>
        </div>

      </div>


      <div class="desc">
        <h4 style="font-size: 18px;">兑换规则</h4>
        <p>
          东部公交工会委员会2026下半年基层班组活动物资套餐选礼指南<br><br>（一）登录方式依次输入工号、姓名、手机号并获取验证码,点击“选品去进入选
          品页面。<br>（二）在选品页面选择自己心仪的套餐-划到底部点击“提交” -
          输入收件人信息后点“提交”，礼完成。<br>（三）本次福利套餐礼包兑换日期为2026年7月6日（周一）至2026年7月10日（周五），每个班组仅可免费兑换一份套餐礼包：<br>（四）如员工不能成功登录兑换平台,由所在单位按如下格式要求重新向公司党委
          工会办公室提交员工信息:<br>姓名、工号、联系电话、单位、部门、车队、岗位、原信息、更新信息;
          <br>（五）需要更改套餐和收件人信息的在兑换期内可联系客服进行更改，逾期不可再更改;<br>（六）物流配送期为:2026年8月1日至10月31日；<br>（七）本次套餐礼包物流配送均为京东/德邦免费邮寄(港澳台及新疆、西藏等偏地区除外);<br>（八）客服咨询总线:13631536713，服务时间周日-至周日09:00-21:00;<br>（九）收到套餐礼包后，清及时核対礼包信息:<br>1.所收礼包与所选的套餐礼包物品一致，包括数量、货物品牌、重量、包装、生产
          日期(所有商品在收货时剩余质保期须超过商品质保期的2/3)等，不符合的可申请
          退货处理;<br>2.套餐礼包物品在配送程中出現坏的，保留好据，及时系供商行更换，<br>3.收到套餐礼包后，如需进行售后的，须在一周内回供应商或公司工会办提出。
        </p>
      </div>
    </div>

  </div>
</template>

<script>
import { showFailToast, showLoadingToast, closeToast, showSuccessToast } from 'vant';
import Api from '../Utils/index.js';

export default {
  name: 'LoginPage',
  props: {
    msg: String
  },
  data() {
    return {
      showWelcome: true,
      countdown: 0,
      info: {
        "name": "",
        "number": "",
        "mobile": "",
        "code": "",
        "company": "",
        "team": "",
        "class": ""
      }
    };
  },
  mounted() {

  },
  methods: {
    onSubmit() {
      this.$refs.form.validate().then(async () => {
        showLoadingToast({
          message: '加载中...',
          duration: 0,
          forbidClick: true,
        })
        try {
          let response = await Api.post('/api/staff/login', {
            name: this.info.name,
            mobile: this.info.mobile,
            number: this.info.number,
            code: this.info.code,
          });
          let resp = await response.json();
          closeToast();
          if (resp.code === 20000) {
            Api.user = resp.data
            console.log(Api.user)
            this.$router.push('/gifts')
          } else {
            showFailToast('填写信息有误')
          }

        } catch (error) {
          showFailToast('填写信息有误')
        }
      })
    },
    getCode() {
      // 验证手机号
      if (!this.info.mobile) {
        showFailToast('请输入手机号');
        return;
      }

      // 调用获取验证码接口
      Api.post('/api/staff/code', {
        mobile: this.info.mobile
      }).then(async (response) => {
        let resp = await response.json();
        if (resp.code === 20000) {
          // 开始倒计时
          this.countdown = 60;
          const timer = setInterval(() => {
            this.countdown--;
            if (this.countdown <= 0) {
              clearInterval(timer);
            }
          }, 1000);
          showSuccessToast('验证码已发送');
        } else {
          showFailToast('发送失败，请重试');
        }
      }).catch(() => {
        showFailToast('发送失败，请重试');
      });
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.hello {
  text-align: left;
}

.form-ct {
  padding: 14px;
}

.form {
  padding: 14px;
  box-sizing: border-box;
  padding: 15px;
  border-radius: 8px;
  background: rgba(255, 255, 255, .2);
}

.desc {
  box-sizing: border-box;
  border-radius: 8px;
  margin: 10px;
  padding: 14px;
  color: #ebebeb;
  font-size: 12px;
  line-height: 20px;
}

.van-cell {
  background: transparent;
  font-size: 14px;

}

/deep/ .van-field__body input {
  color: white !important;
}

/deep/ .van-field__label {
  color: white !important;
  font-weight: 600;
}

/deep/ .van-field__control::-webkit-input-placeholder {
  color: #ffffffd0 !important;
}
</style>